module.exports = __webpack_public_path__ + "img/cave90.4cda067a.jpg";